import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
    <path d="M5 6.78535V17.2161C5 19.3524 7.38344 20.693 9.28571 19.6249L13.9295 17.0199L18.5733 14.404C20.4756 13.3359 20.4756 10.6655 18.5733 9.5974L13.9295 6.98154L9.28571 4.37658C7.38344 3.30844 5 4.63817 5 6.78535Z" />,
    "Play",
);
